import InlineFeedbackPopover from './InlineFeedbackPopover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const FeedbackButton = ({
  featureTestId,
  feedbackDisabled,
  feedbackFormHeaderI18nKey,
  feedbackOptions,
  feedbackPopoverOpen,
  feedbackTooltipI18nKey,
  freeformPlaceholder,
  handleClose,
  handleFeedbackClick,
  handleFeedbackSubmit,
  icon,
  selected
}) => {
  const getIconColor = () => {
    if (feedbackDisabled) {
      return 'icon-primary-disabled';
    }
    return selected ? 'icon-core-on-fill-default' : 'icon-core-default';
  };
  return /*#__PURE__*/_jsx(InlineFeedbackPopover, {
    popoverOpen: Boolean(feedbackOptions) && feedbackPopoverOpen,
    onSubmit: handleFeedbackSubmit,
    onCancel: handleClose,
    feedbackOptions: feedbackOptions,
    freeformPlaceholder: freeformPlaceholder,
    headerI18nKey: feedbackFormHeaderI18nKey,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: feedbackTooltipI18nKey
      }),
      placement: "bottom",
      disabled: feedbackPopoverOpen,
      children: /*#__PURE__*/_jsx(Button, {
        "aria-pressed": selected,
        "data-test-id": featureTestId,
        disabled: feedbackDisabled,
        onClick: handleFeedbackClick,
        padding: "0",
        margin: "0",
        use: "transparent",
        children: /*#__PURE__*/_jsx(IconHolder, {
          icon: icon,
          color: getIconColor(),
          backgroundColor: selected ? 'icon-core-default' : 'icon-core-on-fill-default',
          size: "200"
        })
      })
    })
  });
};
export default FeedbackButton;